import _lowerCase from 'lodash/lowerCase';
import _upperFirst from 'lodash/upperFirst';
import { Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { parseTrackingCheckpointLocation } from '@packlink/packlink-sdk';
import { getTrackingCheckpointStyles, getTrackingCheckpointLabelStyles, getTrackingCheckpointSubtitleStyles, getTrackingCheckpointDescriptionSubtitleStyles, getTrackingCheckpointTimeStyles } from './TrackingCheckpointStyles.js';
import { TrackingLastUpdateLabel } from '../TrackingLastUpdateLabel.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { shouldRenderTrackingStatusRawDescription, getTrackingStatusDescriptionKey } from '../../../../utils/TrackingStatus.js';

function TrackingCheckpoint(_ref) {
  let {
    checkpoint: {
      status,
      occurredAt,
      location,
      rawCarrierStatus
    },
    important,
    isFromTablet,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation();
  const showRawDescription = shouldRenderTrackingStatusRawDescription(status);
  return jsxs("div", {
    css: getTrackingCheckpointStyles,
    ...otherProps,
    children: [important && !isFromTablet && jsx(TrackingLastUpdateLabel, {
      "data-id": "timeline-last-update-label"
    }), jsxs("div", {
      css: getTrackingCheckpointLabelStyles,
      children: [jsx(Typography, {
        variant: "body2",
        bold: important,
        component: "div",
        children: showRawDescription ? rawCarrierStatus.description : t(getTrackingStatusDescriptionKey(status))
      }), location && jsx(Typography, {
        css: getTrackingCheckpointSubtitleStyles,
        variant: "small",
        component: "div",
        children: parseTrackingCheckpointLocation(location)
      }), jsx(Typography, {
        css: getTrackingCheckpointDescriptionSubtitleStyles,
        variant: "small",
        component: "div",
        children: _upperFirst(_lowerCase(rawCarrierStatus.description))
      })]
    }), occurredAt && jsxs("div", {
      css: getTrackingCheckpointTimeStyles,
      children: [jsx(Typography, {
        variant: "body2",
        bold: important,
        component: "div",
        children: occurredAt.format('D MMM YYYY')
      }), jsx(Typography, {
        css: getTrackingCheckpointSubtitleStyles,
        variant: "small",
        component: "div",
        children: occurredAt.format('HH:mm')
      })]
    })]
  });
}

export { TrackingCheckpoint };
//# sourceMappingURL=TrackingCheckpoint.js.map
